var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1B2646;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,15c-1.9,0-3.6-0.7-4.9-2.1C1.7,11.6,1,9.9,1,8s0.7-3.6,2.1-4.9S6.1,1,8,1s3.6,0.7,4.9,2.1 C14.3,4.4,15,6.1,15,8s-0.7,3.6-2.1,4.9C11.6,14.3,9.9,15,8,15z M8,16c2.1,0,4.2-0.8,5.7-2.3C15.2,12.2,16,10.1,16,8 s-0.8-4.2-2.3-5.7C12.2,0.8,10.1,0,8,0S3.8,0.8,2.3,2.3C0.8,3.8,0,5.9,0,8s0.8,4.2,2.3,5.7C3.8,15.2,5.9,16,8,16L8,16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.1,6.6L6.9,6.9L6.9,7.2l0.4,0.1c0.3,0.1,0.3,0.2,0.3,0.5l-0.7,3.3C6.7,12,7,12.4,7.6,12.4 c0.5,0,1.1-0.2,1.4-0.6l0.1-0.4c-0.2,0.2-0.5,0.2-0.7,0.2c-0.3,0-0.4-0.2-0.3-0.5L9.1,6.6z M9.2,4.6c0,0.3-0.1,0.5-0.3,0.7 C8.7,5.4,8.5,5.5,8.2,5.5C8,5.5,7.7,5.4,7.6,5.3C7.4,5.1,7.3,4.8,7.3,4.6c0-0.3,0.1-0.5,0.3-0.7C7.7,3.7,8,3.6,8.2,3.6 c0.3,0,0.5,0.1,0.7,0.3C9.1,4.1,9.2,4.3,9.2,4.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info-blue.c88a239ccbd57860a24405fe5e80790d.svg";
export { ForwardRef as ReactComponent };